import axios from "axios";

export const getTaskCategory = (searchWord, id) => {
  const requestUrl = `/team/task-categories`;

  let params = {
    organization: id,
    param: searchWord
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getClientGroup = (searchWord, id) => {
  const requestUrl = `/team/client-groups`;

  let params = {
    organizationId: id,
    param: searchWord
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getClient = (searchWord, groups, id, typeClients, year) => {
  const requestUrl = `/team/clients`;
  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "name",
        value: searchWord,
        operator: "like"
      }
    ];
  }

  let params = {
    organizationId: id,
    groups: groups,
    filter: JSON.stringify(filter),
    nolimit: true,
    typeClients: typeClients,
    year: year
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getCollaborators = (searchWord, id, zones, squads, years) => {
  const requestUrl = `/team/collaborators`;
  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "name",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  let params = {
    organization: id,
    zones: zones,
    squads: squads,
    filter: JSON.stringify(filter),
    years: years
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getZone = (searchWord, id) => {
  const requestUrl = `/team/zones`;

  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "label",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  let params = {
    organization: id,
    filter: JSON.stringify(filter)
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getBusinessUnit = (searchWord, id) => {
  const requestUrl = `/team/businessUnits`;

  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "label",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  let params = {
    organization: id,
    filter: JSON.stringify(filter)
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getSquads = (searchWord, id) => {
  const requestUrl = `/team/squads`;
  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "label",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  let params = {
    organization: id,
    filter: JSON.stringify(filter)
  };
  return axios.get(requestUrl, {
    params
  });
};

export const getClusters = (searchWord, id) => {
  const requestUrl = `/team/clusters`;
  let filter = [];

  if (searchWord && searchWord.length) {
    filter = [
      {
        property: "label",
        value: searchWord,
        operator: "like"
      }
    ];
  }
  let params = {
    organization: id,
    filter: JSON.stringify(filter)
  };
  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/filter.js